{
  "edit": {
    "name": "Name *"
  },
  "outfitEdit": {
    "name": "Name *",
    "namePlaceholder": "Casual, Formal, Winter…",
    "description": "Description (clothing, shoes, accessories; goes into reference prompt)",
    "kind": "Outfit type",
    "kinds": {
      "garment": {
        "title": "Clothing",
        "hint": "Garments only, on an invisible mannequin, no head. The hero is dressed in the shot."
      },
      "on_character": {
        "title": "On the hero",
        "hint": "The whole hero wearing it, face included. For complex costume, makeup and hair."
      }
    }
  },
  "correction": {
    "title": "Reference correction",
    "hint": "Describe what to change — a new version will be generated from the current image",
    "placeholder": "For example: make hair darker, add glasses, change expression to more serious...",
    "submitting": "Submitting…",
    "generate": "Generate"
  },
  "promptPreview": {
    "title": "Reference prompt",
    "outfitSuffix": " · outfit «{{name}}»",
    "building": "Building prompt…",
    "failed": "Could not build: {{error}}",
    "systemPrompt": "System prompt",
    "userPrompt": "User prompt"
  },
  "references": {
    "title": "Reference versions",
    "base": " · base",
    "scopeHeadlessSuffix": " · headless",
    "outfitSuffix": " · outfit «{{name}}»",
    "hint": "Pick an active version from previously generated ones.",
    "upload": "Upload file",
    "loading": "Loading versions…",
    "empty": "No versions yet. Generate a reference from the character card.",
    "noPreview": "No preview",
    "active": "Active",
    "uploaded": "Uploaded",
    "generated": "Generated",
    "cleared": "Cleared",
    "correct": "Correct",
    "makeActive": "Make active",
    "delete": "Delete",
    "deleteConfirm": "Delete this reference version?"
  },
  "characterSheet": {
    "versionsTitle": "Sheet versions · {{name}}",
    "versionsHint": "Pick an active character sheet version.",
    "versionsEmpty": "No versions yet. Create a sheet from the actions bar.",
    "noPreview": "No preview"
  },
  "characterEmotionSheet": {
    "versionsTitle": "Emotion sheet versions · {{name}}",
    "versionsHint": "Pick an active emotion sheet version.",
    "versionsEmpty": "No versions yet. Generate a sheet from the actions bar.",
    "noPreview": "No preview"
  }
}
